<template>
  <div class="w-full">
    <div class="w-full">
      <Card class="p-5 pt-0">
        <CardFooter reloadcard showcalendar @searchResult="handleSearch($event)" @reload="reload" />
      </Card>
    </div>
    <div class="w-full h-full p-3" />
    <div style="height: 100%" v-if="isLoading">
      <loader size="xxs" :loader-image="false" />
    </div>
    <div v-else>
      <Table :headers="header" :items="tableData" v-if="tableData.length > 0 || loadingTable" aria-label="advance Table"
        class="w-full px-0" :has-checkbox="false" :has-number="false" :pagination-list="metaData"
        @page="handlePage($event)" @itemsPerPage="handleItemsPerPage($event)" page-sync :loading="loadingTable">
        <template v-slot:item="{ item }">
          <div v-if="item.year" class="font-semibold text-sm leading-5 tracking-widest">
            <span class="text-darkPurple">{{ item.data.year }}</span>
          </div>
          <div v-else-if="item.description" class="font-semibold text-sm leading-5 tracking-widest">
            <span class="text-darkPurple">{{ item.data.description }}</span>
          </div>
          <div v-else-if="item.appraisals" class="py-4 flex gap-1">
            {{ item.data.appraisals }}
            <icon icon-name="icon-eye" @click.native="openModal(item.data)"
              class-name="text-blueCrayola cursor-pointer mr-2" size="xs" />
          </div>
          <div v-else-if="item.status">
            <Badge :label="item.data.status" v-if="item.data.status !== ''" variant="primary" :background-color="item.data.status === 'active'
              ? 'rgba(19, 181, 106, 0.15)'
              : 'rgba(135, 142, 153, 0.15)'
              " :color="item.data.status === 'active' ? '#13B56A' : '#878E99'" class="capitalize" style="
                margin-right: 12px;
                font-size: 14px;
                padding: 12px 10px;
                height: 35px;
                border-radius: 5px;
              " />
            <span v-else>---</span>
          </div>
          <div v-else-if="item.id" class="cursor-pointer">
            <div @click="
              $router.push({
                name: 'EssMyAppraisals',
                params: {
                  year: item.data.year,
                  user: $AuthUser.id,
                  cycle: tabsCycles[0],
                  goalId: item.data.id,
                },
              })
              ">
              <Icon icon-name="icon-eye" class-name="text-blueCrayola" size="xs" />
            </div>
          </div>
        </template>
      </Table>

      <div v-else>
        <div class="w-full flex flex-col justify-center items-center mt-20">
          <icon icon-name="empty_agreement" size="l" style="width: 300px" />
          <div class="w-1/2 text-base text-center">
            No performance appraisal displayed.
          </div>
        </div>
      </div>
    </div>



    <Modal v-if="showModal">
      <Card class="p-5 flex flex-col w-full max-w-xl rounded-lg">
        <div class="w-full p-2 mx-auto bg-white">
          <div class="flex justify-between items-center mb-6">
            <h1 class="text-xl font-bold text-gray-800">{{ appraisalData.appraisals }} Appraisals</h1>
          </div>

          <div class="mb-4">
            <h2 class="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">Appraisal periods breakdown
            </h2>

            <div class="w-full flex flex-col border rounded-md space-y-1">
              <div class="p-4 flex w-full justify-between items-center gap-2"
                v-for="(item, index) in appraisalData.appraisalSchedule" :key="index">
                <h3 class="font-bold text-gray-800 mb-1">{{ item.name.toUpperCase() }}:</h3>
                <p class="text-gray-600">
                  {{ item.appraisal_starts && item.appraisal_ends
                    ? `${formatDateTime(item.appraisal_starts)} - ${formatDateTime(item.appraisal_ends)}`
                    : '---' }}
                </p>
              </div>

            </div>
          </div>

          <Button class="bg-dynamicBackBtn text-center text-white" @click="closeModal()">
            Close
          </Button>
        </div>
      </Card>
    </Modal>
  </div>
</template>

<script>
import Table from "@scelloo/cloudenly-ui/src/components/table";
import Card from "@scelloo/cloudenly-ui/src/components/card";
import Badge from "@scelloo/cloudenly-ui/src/components/badge";
import CardFooter from "@/components/CardFooter";
import Modal from "@/components/Modal";
import Button from "@/components/Button";
import paramsMixin from "@/utilities/paramsMixin";
import timeFormatMixin from "@/utilities/timeFormatMixin";

export default {
  name: "MyAppraisals",
  mixins: [paramsMixin, timeFormatMixin],
  components: {
    Table,
    Card,
    Modal,
    Button,
    CardFooter,
    Badge,
  },
  data() {
    return {
      loadingTable: true,
      paginationList: {
        page: 1,
        lastPage: 1,
        total: 1,
        from: 1,
        to: 1,
      },
      header: [
        { title: "Financial Year", value: "year" },
        { title: "Description", value: "description" },
        { title: "Period", value: "periodStart" },
        { title: "Appraisals", value: "appraisals" }
      ],
      tableData: [],
      isLoading: true,
      appraisalsArr: [],
      shortTermGoals: [],
      appraisalStatus: [],
      approvedAgreement: false,
      tabsCycles: [],
      showModal: false,
      searchQuery: "",
      metaData: {},
      appraisalData: {},
      itemsPerPage: null,
      numberOfPage: null,
    };
  },
  methods: {
    openModal(data) {
      this.showModal = true;

      if (data.appraisalSchedule && Array.isArray(data.appraisalSchedule) && data.appraisalSchedule.length > 0) {
        this.appraisalData = data;
        return;
      }

      let appraisalSchedule = [];

      appraisalSchedule = data.cycles;

      this.$set(data, 'appraisalSchedule', appraisalSchedule);
      this.appraisalData = data;
    },

    closeModal() {
      this.appraisalData = null;
      this.showModal = false;
    },

    handleItemsPerPage(itemNo) {
      this.itemsPerPage = itemNo;
      this.queryUpdate();
    },

    handlePage(pageNumber) {
      this.numberOfPage = pageNumber;
      this.queryUpdate();
    },

    queryUpdate() {
      this.loadingTable = true;
      const search = this.searchQuery ? `&${this.searchQuery}` : "";
      const pageNumber = this.numberOfPage
        ? `&page=${this.numberOfPage}`
        : `&page=${this.metaData.page}`;
      const itemPage = this.itemsPerPage ? `&perPage=${this.itemsPerPage}` : "";
      this.getOrganizationGoal(`?${pageNumber}${itemPage}${search}`);
    },

    handleSearch(value) {
      this.searchQuery = `search=${value}`;
      this.loadingTable = true;
      this.getOrganizationGoal(`?${this.searchQuery}`);
    },

    percentage(value, total) {
      return Math.round((value / total) * 100);
    },

    reload() {
      if (this.tableData.length > 0) {
        this.loadingTable = true;
        this.tableData = [];
      } else {
        this.isLoading = true;
      }
      this.getOrganizationGoal('');
    },

    getEmployeeAppraisal() {
      this.$_getEmployeeAppraisal(this.$AuthUser.id).then((result) => {
        const responseData = result.data.EmployeeAppraisal;
        const appraisalStatus = [];
        responseData.forEach((response) => {
          appraisalStatus.push({
            status: response.appraisal.appraisal_state,
          });
        });

        if (responseData.length === 0) {
          appraisalStatus.push({
            status: "",
          });
        }

        this.appraisalStatus.push(
          appraisalStatus.reduce((r, i) => Object.assign(r, i), {})
        );

        this.getOrganizationGoal('');
      });
    },

    getOrganizationGoal(params) {
      this.shortTermGoals = [];
      this.tableData = [];

      this.$_getOrganizationGoal(params)
        .then((response) => {
          const goalData = response.data.goals;
          const currentYear = new Date().getFullYear();
          this.metaData = response.data.meta;

          if (goalData.length > 0) {
            const arr = [];
            goalData.forEach((goals) => {
              if (Number(goals.goal.year) === currentYear) {
                if (this.approvedAgreement) {
                  arr.push({
                    id: goals.goal.id,
                    year: goals.goal.year,
                    description:
                      goals.goal.goal_performance_templates.agreement_title,
                  });
                }
              } else {
                arr.push({
                  id: goals.goal.id,
                  year: goals.goal.year,
                  description:
                    goals.goal.goal_performance_templates.agreement_title,
                });
              }
              return {};
            });

            if (arr.length > 0) {
              arr.push(
                this.appraisalsArr.reduce((r, i) => Object.assign(r, i), {})
              );
              arr.push(
                this.appraisalStatus.reduce((r, i) => Object.assign(r, i), {})
              );
              this.tableData.push(
                arr.reduce((r, c) => Object.assign(r, c), {})
              );
            }
          }
          this.isLoading = false;
          this.loadingTable = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.loadingTable = false;
        });
    },

    getAppraisalCycle() {
      this.$_getAppraisalCycle(this.appraisalQuery()).then((response) => {
        const appraisal = response.data.AppraisalCycle;
        const apprArray = [];
        appraisal.map((appraisalCycles) => {
          const startDate = `${appraisalCycles.cycle_start_date}`;
          const endDate = `${appraisalCycles.cycle_end_date}`;
          apprArray.push({
            periodStart: `${this.formatDateTime(
              startDate
            )} - ${this.formatDateTime(endDate)}`,
            appraisals: appraisalCycles.appraisal_frequency,
            cycles: appraisalCycles.cycles
          });
          appraisalCycles.cycles.map((cycle) => {
            this.tabsCycles.push(cycle.name);
          });

          this.appraisalsArr.push(
            apprArray.reduce((r, i) => Object.assign(r, i), {})
          );
          this.header.push(
            { title: "Status", value: "status" },
            { title: "", value: "id", image: true }
          );
          return {};
        });
        this.getEmployeeAppraisal();
      });
    },

    getAgreements() {
      this.$_getEmployeeAgreement(this.$AuthUser.id).then((response) => {
        const myAgreements = response.data.EmployeePerformanceAgreements;
        const currentYear = new Date().getFullYear();

        myAgreements.map((agreement) => {
          if (Number(agreement.year) === currentYear) {
            this.approvedAgreement = agreement.approvedByAdmin;
          }
          return {};
        });

        this.getAppraisalCycle();
      });
    },
  },

  mounted() {
    this.getAgreements();
  },
};
</script>
<style scoped>
.font-size-10 {
  font-size: 10px;
}
</style>